interface ScopeDisclaimerProps {
  neighborhood: string;
}

export default function ScopeDisclaimer({ neighborhood }: ScopeDisclaimerProps) {
  return (
    <section className="w-full bg-white py-8 md:py-10 px-4 md:px-6">
      <div className="max-w-[880px] mx-auto">
        <div className="bg-[#fefce8] rounded-xl p-6 border-l-4 border-l-[#047857]">
          <h3 className="font-bold text-lg text-[#064e3b] mb-2">
            Honest Scope in {neighborhood}
          </h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            We provide minor repair and maintenance services in {neighborhood}. We do not install new windows or perform structural work. For installations, we refer you to licensed Florida contractors at no cost.
          </p>
        </div>
      </div>
    </section>
  );
}